import { render } from "./ApplianceDialog.vue?vue&type=template&id=f85fb95c&ts=true"
import script from "./ApplianceDialog.vue?vue&type=script&lang=ts"
export * from "./ApplianceDialog.vue?vue&type=script&lang=ts"

import "./ApplianceDialog.vue?vue&type=style&index=0&id=f85fb95c&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__